import React, { useState } from 'react';
import { db } from './FBConfigs';
import { doc, setDoc } from 'firebase/firestore';
import Swal from 'sweetalert2';
import { useTheme } from './ThemeContext';
import { useNavigate } from 'react-router-dom';
import './App.css';

function AdminUpdatePage() {
  const { theme } = useTheme();
  const navigate = useNavigate();

  const [userType, setUserType] = useState('Patient');
  const [patientData, setPatientData] = useState({
    fullName: '', 
    age: '', 
    gender: '', 
    bloodType: '', 
    allergies: '', 
    diagnosis: '', 
    medications: '', 
    lastVisit: '', 
    doctorAssigned: ''
  });
  const [doctorData, setDoctorData] = useState({
    fullName: '', 
    age: '', 
    gender: '', 
    doctorSpecialization: '', 
    doctorContactNumber: '', 
    doctorAddress: '', 
    doctorEmail: '', 
    doctorOperations: ''
  });

  const handleChange = (e) => {
    const { name, value } = e.target;

    if (userType === 'Patient') {
      setPatientData((prev) => ({ ...prev, [name]: value }));
    } else {
      setDoctorData((prev) => ({ ...prev, [name]: value }));
    }
  };
  
  const handleSubmit = async (e) => {
    e.preventDefault();

    let uniqueId = '';
    if (userType === 'Patient') {
      const patientPrefix = (patientData.fullName || 'XXX').substring(0, 3).toUpperCase();
      const doctorPrefix = (patientData.doctorAssigned || 'XXX').substring(0, 3).toUpperCase();
      const uniqueNumber = Math.floor(1000000 + Math.random() * 9000000).toString();
      uniqueId = `${patientPrefix}${uniqueNumber}${doctorPrefix}`;

      await setDoc(doc(db, 'patients', uniqueId), {
        ...patientData,
        uniqueId,
        userType,
        addedAt: new Date(),
      });
    } else {
      const doctorPrefix = (doctorData.fullName || 'XXX').substring(0, 3).toUpperCase();
      const uniqueNumber = Math.floor(1000000 + Math.random() * 9000000).toString();
      uniqueId = `DOC${uniqueNumber}${doctorPrefix}`;

      await setDoc(doc(db, 'doctors', uniqueId), {
        ...doctorData,
        uniqueId,
        userType,
        addedAt: new Date(),
      });
    }

    Swal.fire({
      icon: 'success',
      title: `${userType} Created`,
      html: `
        <div style="font-size:1rem;">
          ✅ ${userType} successfully added.<br/>
          <strong>${userType} ID:</strong> ${uniqueId}
        </div>`,
    });

    // Reset form
    setPatientData({
      fullName: '', 
      age: '', 
      gender: '', 
      bloodType: '', 
      allergies: '', 
      diagnosis: '', 
      medications: '', 
      lastVisit: '', 
      doctorAssigned: ''
    });
    setDoctorData({
      fullName: '', 
      age: '', 
      gender: '', 
      doctorSpecialization: '', 
      doctorContactNumber: '', 
      doctorAddress: '', 
      doctorEmail: '', 
      doctorOperations: ''
    });
    navigate('/');
  };
  
  return (
    <div className={`admin-update-page ${theme}`} style={{ padding: '2rem' }}>
      <h2>Admin - Add New {userType}</h2>
      <div className="user-type-toggle">
        <button
          className={userType === 'Patient' ? 'active' : ''}
          onClick={() => setUserType('Patient')}
        >
          Patient
        </button>
        <button
          className={userType === 'Doctor' ? 'active' : ''}
          onClick={() => setUserType('Doctor')}
        >
          Doctor
        </button>
      </div>

      <form className="user-form" onSubmit={handleSubmit}>
        <input required name="fullName" placeholder="Full Name"
               value={userType === 'Patient' ? patientData.fullName : doctorData.fullName}
               onChange={handleChange} />
        <input required name="age" placeholder="Age"
               value={userType === 'Patient' ? patientData.age : doctorData.age}
               onChange={handleChange} />
        <input required name="gender" placeholder="Gender"
               value={userType === 'Patient' ? patientData.gender : doctorData.gender}
               onChange={handleChange} />

        {userType === 'Patient' && (
          <>
            <input required name="bloodType" placeholder="Blood Type" value={patientData.bloodType} onChange={handleChange} />
            <input name="allergies" placeholder="Allergies" value={patientData.allergies} onChange={handleChange} />
            <input name="diagnosis" placeholder="Diagnosis" value={patientData.diagnosis} onChange={handleChange} />
            <input name="medications" placeholder="Medications" value={patientData.medications} onChange={handleChange} />
            <input name="lastVisit" placeholder="Last Visit (YYYY-MM-DD)" value={patientData.lastVisit} onChange={handleChange} />
            <input required name="doctorAssigned" placeholder="Doctor Assigned" value={patientData.doctorAssigned} onChange={handleChange} />
          </>
        )}

        {userType === 'Doctor' && (
          <>
            <input required name="doctorSpecialization" placeholder="Specialization" value={doctorData.doctorSpecialization} onChange={handleChange} />
            <input required name="doctorContactNumber" placeholder="Contact Number" value={doctorData.doctorContactNumber} onChange={handleChange} />
            <input required name="doctorAddress" placeholder="Address" value={doctorData.doctorAddress} onChange={handleChange} />
            <input required name="doctorEmail" placeholder="Email" value={doctorData.doctorEmail} onChange={handleChange} />
            <input required name="doctorOperations" placeholder="List of Operations" value={doctorData.doctorOperations} onChange={handleChange} />
          </>
        )}

        <button type="submit">Add {userType}</button>
      </form>
    </div>
  );
}

export default AdminUpdatePage;
